import React, { Component } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import RenderInput from './RenderInput';

import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import Typography from '@material-ui/core/Typography';


const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
}));

const Refs = [];
const Add = (props) => {

    const classes = useStyles();
    const { open, handleClose, formTitle, addButtonTitle, editButtonTitle, inputs, listName, saveData, data } = props;

    return <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
            timeout: 500,
        }}
    >
        <Fade in={open}>
            <div className={classes.paper}>
                <form className={classes.form} onSubmit={(e) => {
                    e.preventDefault();

                    let inputs = {};
                    let invalidVal = false;
                    Refs.forEach((input) => {
                        console.log("input : ", input)
                        if (input.props.restrictedValues) {
                            input.props.restrictedValues.forEach((val) => {
                                if (input.state[input.props.id].toLowerCase() == val.toLowerCase()) {
                                    invalidVal = true;
                                    alert(`${input.state[input.props.id]} is invalid in ${input.props.title}`);
                                    return;
                                }
                            })
                        }
                        inputs = { ...inputs, ...input.state, id : data && data.id };
                    })

                    if (!invalidVal) {
                        saveData(inputs);
                    }

                }}>
                    <Typography variant="h4">{formTitle}</Typography>
                    {
                        inputs && inputs.length ? inputs.map((input, i) => {
                            return (
                                <RenderInput ref={elem => Refs[i] = elem} key={input.id} {...input} defaultValue={data && data[input.id]} />
                            )
                        })
                            : null
                    }
                    <Button
                        style={{ margin: '20px 0' }}
                        variant="contained"
                        color="primary"
                        type="submit"
                    >{data ? editButtonTitle : addButtonTitle} </Button>
                </form>
            </div>
        </Fade>
    </Modal>
}

export default Add